module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-filter"
  }, [(_vm.item.fieldType === 4) ? [(_vm.label) ? _c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.item.attrName) + ":")]) : _vm._e(), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "padding": "0 10px"
    },
    attrs: {
      "unlink-panels": "",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "clearable": "",
      "type": "daterange",
      "align": "right",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions,
      "size": "small"
    },
    on: {
      "change": _vm.handleSelect
    },
    model: {
      value: (_vm.arr),
      callback: function($$v) {
        _vm.arr = $$v
      },
      expression: "arr"
    }
  })] : ([1, 2, 7, 61].indexOf(_vm.item.fieldType) > -1 || _vm.item.attr === 'address' || _vm.item.attr === 'phone') ? [(_vm.label) ? _c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.item.attrName) + ":")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.str),
      expression: "str"
    }],
    staticClass: "v-input",
    attrs: {
      "type": "text",
      "placeholder": "输入关键词搜索"
    },
    domProps: {
      "value": (_vm.str)
    },
    on: {
      "change": _vm.handleSelect,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.str = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.str) ? _c('i', {
    staticClass: "el-icon-close",
    on: {
      "click": function($event) {
        _vm.clearValue(_vm.item.attr)
      }
    }
  }) : _vm._e()] : (_vm.item.fieldType === 10) ? [(_vm.label) ? _c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.item.attrName) + ":")]) : _vm._e(), _vm._v(" "), _c('el-select', {
    attrs: {
      "size": "small",
      "multiple": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.handleArr
    },
    model: {
      value: (_vm.arr),
      callback: function($$v) {
        _vm.arr = $$v
      },
      expression: "arr"
    }
  }, _vm._l((_vm.star), function(s) {
    return _c('el-option', {
      key: s.value,
      attrs: {
        "label": s.label,
        "value": s.value
      }
    })
  }))] : (_vm.item.fieldType === 3) ? [(_vm.label) ? _c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.item.attrName) + ":")]) : _vm._e(), _vm._v(" "), _c('el-select', {
    attrs: {
      "size": "small",
      "multiple": "",
      "collapse-tags": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.handleArr
    },
    model: {
      value: (_vm.arr),
      callback: function($$v) {
        _vm.arr = $$v
      },
      expression: "arr"
    }
  }, [(_vm.item.valueArrMap) ? _vm._l((_vm.item.valueArrMap), function(arr) {
    return _c('el-option', {
      key: arr.value,
      attrs: {
        "label": arr.value,
        "value": arr.key
      }
    })
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.strToArr(_vm.item.initValue)), function(option) {
    return _c('el-option', {
      key: option,
      attrs: {
        "value": option
      }
    })
  })], 2)] : ((_vm.item.fieldType === 9 || _vm.item.attr === 'warehouseId')) ? [(_vm.label) ? _c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.item.attrName) + ":")]) : _vm._e(), _vm._v(" "), _c('el-select', {
    attrs: {
      "clearable": "",
      "size": "small",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.handleSelect
    },
    model: {
      value: (_vm.str),
      callback: function($$v) {
        _vm.str = $$v
      },
      expression: "str"
    }
  }, [(_vm.item.valueArrMap) ? _vm._l((_vm.item.valueArrMap), function(label, value) {
    return _c('el-option', {
      key: value,
      attrs: {
        "label": label,
        "value": value
      }
    })
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.strToArr(_vm.item.initValue)), function(option) {
    return _c('el-option', {
      key: option,
      attrs: {
        "value": option
      }
    })
  })], 2)] : (_vm.item.attr === 'categoryId') ? [_c('div', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: (_vm.closeFilter),
      expression: "closeFilter"
    }]
  }, [(_vm.label) ? _c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.item.attrName) + ":")]) : _vm._e(), _vm._v(" "), _c('input', {
    staticClass: "v-input",
    attrs: {
      "type": "text",
      "readonly": "",
      "placeholder": "请选择分类"
    },
    domProps: {
      "value": _vm.selectCate4Show
    },
    on: {
      "focus": _vm.showCategray
    }
  }), _vm._v(" "), (_vm.selectCate.length) ? _c('i', {
    staticClass: "el-icon-close",
    on: {
      "click": _vm.clearCate
    }
  }) : _vm._e(), _vm._v(" "), (_vm.categrayShow) ? _c('div', {
    staticClass: "categray"
  }, [_c('el-tree', {
    attrs: {
      "data": _vm.categories,
      "props": _vm.defaultProps,
      "show-checkbox": ""
    },
    on: {
      "check-change": _vm.handleCheckChange
    }
  })], 1) : _vm._e()])] : (_vm.item.attr === 'isPublic') ? [(_vm.label) ? _c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.item.attrName) + ":")]) : _vm._e(), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-text": "",
      "inactive-text": "",
      "active-color": "#ff7c35"
    },
    on: {
      "change": _vm.handlePublic
    },
    model: {
      value: (_vm.showPublic),
      callback: function($$v) {
        _vm.showPublic = $$v
      },
      expression: "showPublic"
    }
  })] : [(_vm.label) ? _c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.item.attrName) + ":")]) : _vm._e()]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1cfdef73","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/filter.vue
// module id = 1228
// module chunks = 82